import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <section className="py-32 min-h-[70vh] flex items-center">
      <div className="container-x text-center">
        <p className="giant-num text-[160px] lg:text-[240px] text-[#C6C4CF]">404</p>
        <h1 className="heading-display text-[40px] lg:text-[64px] mt-2">Page not found</h1>
        <p className="mt-6 text-[#C6C4CF]">The page you are looking for does not exist.</p>
        <Link to="/" className="btn-outline mt-10 inline-flex"><span>Back to home</span><span className="arrow"><ArrowUpRight size={14} /></span></Link>
      </div>
    </section>
  );
}
